import { createSlice } from '@reduxjs/toolkit';

const messageSlice = createSlice({
    name: 'message',
    initialState: {
        visible: false,
        level: 'success',
        message: null
    },
    reducers: {
        showToast: (state, action) => {
            state.visible = action.payload.visible;
            state.level = action.payload.level;
            state.message = action.payload.message;
        },
        hideToast: (state) => {
            state.visible = false;
        }
    }
});

export const { showToast, hideToast } = messageSlice.actions;
export default messageSlice.reducer;
